const initialState = {
  loading: false,
  data: null,
  error: null,
};

const homeBannerChooserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_HOME_BANNER_CHOOSER_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_HOME_BANNER_CHOOSER_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_HOME_BANNER_CHOOSER_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default homeBannerChooserReducer;
